// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__1DLg-","header":"ClearentDisclaimer_header__7Qju-","inner":"ClearentDisclaimer_inner__2NmRE"};